module.exports = __webpack_public_path__ + "components/rewards/isobaa/static/logo-fc65b3e748d444ceb069c7606a044a3a.jpg";